<div class="col gap-8">
    <h4>Selected Package:</h4>
    <div class="row gap-8">
        @for (cat of selectedStack; track cat) {
            <rr-badge
                icon="trash"
                class="pointer"
                (click)="deleteCategorie(cat)"
                >{{ cat | getCategoryNameById }}</rr-badge
            >
        }
    </div>
</div>
<div class="col gap-8">
    <h4>Select Domain & Package:</h4>
    <div class="row gap-8">
        @for (category of catStructure; track category.id) {
            <rr-badge
                (click)="setParentActive(category.id)"
                class="pointer"
                [tone]="category.active === true ? 'success' : 'neutral'"
                >{{ category.name }}</rr-badge
            >
        }
    </div>
</div>
@if (secondLevel.length > 0) {
    <rr-divider></rr-divider>
    <div class="col gap-8">
        <h4>Select package for the Stream</h4>
        <div class="row gap-8">
            @for (child of secondLevel; track child) {
                <rr-badge
                    (click)="selectCategorie(child)"
                    class="pointer"
                    tone="neutral"
                    >{{ child | getCategoryNameById }}</rr-badge
                >
            }
        </div>
    </div>
}
